module.exports = __webpack_public_path__ + "img/tifo.908d6107.png";